import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { ReactNode } from "react";

type InfoDialogProps = {
  isDialogOpen: boolean;
  handleClose: () => void;
  color: string;
  title: string;
  content: ReactNode;
};

export default function InfoDialog({
  isDialogOpen,
  handleClose,
  color,
  title,
  content,
  ...rest
}: InfoDialogProps) {
  return (
    <Dialog {...rest} open={isDialogOpen} onClose={handleClose}>
      <DialogTitle color={color} id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText component={"span"} id="alert-dialog-description">
          {content}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}
